import {
  LocationModel,
  PlaceModel,
  VehicleModel,
  VehicleSearchResultModel,
} from './../api-model';

// export function locationModelFromLocationInfo(locationInfo: LocationInfo) {
//   return <LocationModel>{
//     latitude: locationInfo.latitude,
//     longitude: locationInfo.longitude,
//     displayLine1: locationInfo.placeName,
//     displayLine2: locationInfo.suburb,
//     placeId:locationInfo.placeId
// }
// }

export function locationModelFromPlaceModel(place: PlaceModel) {
  return <LocationModel | any>{
    placeId: place.id,
    latitude: place.latitude,
    longitude: place.longitude,
    displayLine1: place.displayLine1,
    displayLine2: place.displayLine2,
  };
}

export function vehicleModelFromVehicleSearchResultModel(
  searchResult: VehicleSearchResultModel
): VehicleModel {
  const vehicle: any = {
    vehicleId: searchResult.vehicleId,
    networkId: searchResult.networkId,
    status: searchResult.status,
    make: searchResult.make,
    model: searchResult.model,
    series: searchResult.series,
    vin: searchResult.vin,
    displayName: searchResult.vehicleDisplayName,
    networkName: searchResult.networkDisplayName,
    plate: {
      plateNumber: searchResult.plateNumber,
    } as any,
    effectiveFrom: searchResult.effectiveFrom,
    effectiveTo: searchResult.effectiveTo,
    medallion: {
      medallionNumber: searchResult.medallionNumber,
      type: searchResult.medallionType,
    },
    // Set other properties to default or null values
    externalSystemReference: '',
    networkGroupId: '',
    operatorId: '',
    networkServiceId: '',
    modelId: '',
    vehicleRegistrationId: '',
    vehicleRegistration: null,
    vehicleAuthorityId: '',
    travellerCapacity: null,
    colourName: '',
    colourValue: '',
    vehiclePhotoFront: null,
    vehiclePhotoBack: null,
    vehiclePhotoLeft: null,
    vehiclePhotoRight: null,
    vehicleDetailsDocument: null,
    networkServices: [],
    conditions: [],
    attributes: [],
    assets: [],
    position: null,
    planModel: null,
    operatorPlanModel: null,
    deleted: false,
  };
  return vehicle;
}
